<style lang="stylus">
    .shadow-panel {
        padding-top: 4px;
        position: relative;
        .rPanel-item {
            margin-bottom: 12px;
            .ivu-select {
                width: 80px;
                margin-left: auto;
            }
            .shadow-downs {
                min-width: 80px;
                width: fit-content;
                padding: 6px;
                border-radius: 8px;
                background-color: $navigation-modal-bgcolor
                box-shadow $common-box-shadow
                box-sizing border-box;
                border: none;
                .item-down {
                    height: 32px;
                    line-height: 22px;
                    border-radius: 6px;
                    padding: 5px 10px;
                    &:hover {
                        background-color: $main-hovercolor
                    }
                }
            }
        }
        .mask {
            z-index: 1;
            position: absolute;
            top: 0;
            left: -8px;
            bottom: 0;
            right: 0;
            background-color: rgba(255, 255, 255, 0);
        }
    }
    .noShadowMask {
        top: 45px !important; //item height+padding
    }
</style>
<style lang="stylus">
    .shadow-panel
        border-bottom-left-radius $right-view-radius
        border-bottom-right-radius $right-view-radius
        color $right-view-content-textcolor
    .mmBlock
        pointer-events none
        opacity .6
</style>

<template>
    <div class="shadow-panel" :class="{ mmBlock: isMMShape }">
        <div class="rPanel-item" :class="{ disabled: !isSelect }">
            <span class="left">{{ $t("ShadowPanel.preset") }}</span>
            <i-select
                :transfer="true"
                size="small"
                :value="activePresetsText"
                @on-change="setPresets($event)"
                :disabled="!isSelect"
                :placement="'bottom-end'"
            >
                <i-option v-for="n in 4" :value="presetsText(n - 1)" :key="presetsText(n - 1)">
                    {{ $t(presetsText(n - 1)) }}
                </i-option>
            </i-select>
        </div>
        <template v-if="!activePresetsDisabled">
            <ColorSet :from="fmtType.shadow" :isDisabled="activePresetsDisabled || !isSelect" :index="0" @changeSet="handleChangeSet" />
            <div class="colorSet-item" :class="{ disabled: activePresetsDisabled || disabledSize }">
                <div class="colorSet-item-title">{{ $t("ShadowPanel.size") }}</div>
                <div class="colorSet-slider-box">
                    <Slider
                        :max="200"
                        :min="0"
                        v-model="sizeVal"
                        @on-change="changeSize()"
                        :disabled="activePresetsDisabled || disabledSize"
                        @mouseup.native="handleChangeSet"
                    ></Slider>
                    <InputNumber
                        class="input-num"
                        :max="200"
                        :min="0"
                        :step="1"
                        style="width: 80px"
                        size="small"
                        v-model="sizeVal"
                        :disabled="activePresetsDisabled || disabledSize"
                        :active-change="false"
                        :formatter="(value) => `${value}%`"
                        :parser="(value) => value.replace('%', '')"
                        @on-focus="editLocker('focus', 'inputLocker')"
                        @on-blur="
                            editLocker('blur', 'inputLocker', () => {
                                changeSize();
                            })
                        "
                        @on-change="
                            editLocker('edit', 'inputLocker', () => {
                                changeSize();
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
            </div>
            <div class="colorSet-item" :class="{ disabled: activePresetsDisabled }">
                <div class="colorSet-item-title">{{ $t("ShadowPanel.blur") }}</div>
                <div class="colorSet-slider-box">
                    <Slider
                        :max="100"
                        :min="0"
                        v-model="blurVal"
                        @on-change="changeBlur()"
                        :disabled="activePresetsDisabled"
                        @mouseup.native="handleChangeSet"
                    ></Slider>
                    <InputNumber
                        class="input-num"
                        :max="100"
                        :min="0"
                        :step="1"
                        style="width: 80px"
                        size="small"
                        v-model="blurVal"
                        :disabled="activePresetsDisabled"
                        :active-change="false"
                        :formatter="(value) => `${value} pt`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        @on-focus="editLocker('focus', 'inputLocker')"
                        @on-blur="
                            editLocker('blur', 'inputLocker', () => {
                                changeBlur();
                            })
                        "
                        @on-change="
                            editLocker('edit', 'inputLocker', () => {
                                changeBlur();
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
            </div>
            <div class="colorSet-item">
                <div class="colorSet-item-title" :class="{ disabled: disabledAngle }">{{ $t("ShadowPanel.angle") }}</div>
                <div class="colorSet-slider-box">
                    <Slider
                        :max="360"
                        :min="0"
                        :disabled="disabledAngle"
                        v-model="angleVal"
                        @on-change="changeAngle()"
                        @mouseup.native="handleChangeSet"
                    ></Slider>
                    <InputNumber
                        class="input-num"
                        :max="360"
                        :min="0"
                        style="width: 80px"
                        size="small"
                        :disabled="disabledAngle"
                        v-model="angleVal"
                        :active-change="false"
                        :formatter="(value) => `${value} deg`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        @on-focus="editLocker('focus', 'inputLocker')"
                        @on-blur="
                            editLocker('blur', 'inputLocker', () => {
                                changeAngle();
                            })
                        "
                        @on-change="
                            editLocker('edit', 'inputLocker', () => {
                                changeAngle();
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
            </div>
            <div class="colorSet-item" :class="{ disabled: activePresetsDisabled }">
                <div class="colorSet-item-title">{{ $t("ShadowPanel.Xoffset") }}</div>
                <div class="colorSet-slider-box">
                    <Slider
                        :max="200"
                        :min="-200"
                        v-model="xOffVal"
                        @on-change="changeOffX()"
                        :disabled="activePresetsDisabled"
                        @mouseup.native="handleChangeSet"
                    ></Slider>
                    <InputNumber
                        class="input-num"
                        :max="200"
                        :min="-200"
                        style="width: 80px"
                        size="small"
                        v-model="xOffVal"
                        :disabled="activePresetsDisabled"
                        :active-change="false"
                        :formatter="(value) => `${value} pt`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        @on-focus="editLocker('focus', 'inputLocker')"
                        @on-blur="
                            editLocker('blur', 'inputLocker', () => {
                                changeOffX();
                            })
                        "
                        @on-change="
                            editLocker('edit', 'inputLocker', () => {
                                changeOffX();
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
            </div>
            <div class="colorSet-item" :class="{ disabled: activePresetsDisabled }">
                <div class="colorSet-item-title">{{ $t("ShadowPanel.Yoffset") }}</div>
                <div class="colorSet-slider-box">
                    <Slider
                        :max="200"
                        :min="-200"
                        v-model="yOffVal"
                        @on-change="changeOffY()"
                        :disabled="activePresetsDisabled"
                        @mouseup.native="handleChangeSet"
                    ></Slider>
                    <InputNumber
                        class="input-num"
                        :max="200"
                        :min="-200"
                        style="width: 80px"
                        size="small"
                        v-model="yOffVal"
                        :disabled="activePresetsDisabled"
                        :active-change="false"
                        :formatter="(value) => `${value} pt`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        @on-focus="editLocker('focus', 'inputLocker')"
                        @on-blur="
                            editLocker('blur', 'inputLocker', () => {
                                changeOffY();
                            })
                        "
                        @on-change="
                            editLocker('edit', 'inputLocker', () => {
                                changeOffY();
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
            </div>
        </template>
        <div class="mask" :class="{ noShadowMask: noShadowMasked }" v-show="masked"></div>
    </div>
</template>

<script lang="ts">
    declare var eFmtSetFlag: any;
    enum Presets {
        "No Shadow",
        Outer,
        Inner,
        Perspective,
    }
    import ColorSet from "./ColorSet.vue";
    import { Component, Prop, Watch, Vue, Inject } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            ColorSet,
        },
    })
    export default class ShadowPanel extends Vue {
        @Inject()
        ["iviewInputBlur"];

        inputLocker: boolean = false;
        showPresets: boolean = false;
        noShadowMasked: boolean = false;
        masked: boolean = false;
        color: string = "#000000";
        get isMMShape() {
            return this.$store.state.shape.isMMShape;
        }

        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }

        get activePresetsDisabled() {
            return this.activePresets == 0;
        }
        setPresets(n) {
            n = Presets[n];
            window["_view"]._tool.endEdit();
            let view = window["_view"];
            this.activePresets = n;
            view.setFmt(
                {
                    _mode: n,
                },
                eFmtSetFlag.ShadowMode
            );
            this.$nextTick(() => {
                this.showPresets = false;
            });
            this.handleChangeSet();
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                        this.handleChangeSet();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                            this.handleChangeSet();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        changeSize() {
            this.$nextTick(() => {
                window["_view"]._tool.endEdit();
                let view = window["_view"];
                view.setFmt(
                    {
                        _size: this.sizeVal,
                    },
                    eFmtSetFlag.ShadowSize
                );
            });
        }
        changeAngle() {
            this.$nextTick(() => {
                window["_view"]._tool.endEdit();
                let view = window["_view"];
                view.setFmt(
                    {
                        _angle: this.angleVal,
                    },
                    eFmtSetFlag.ShadowAngle
                );
            });
        }
        changeBlur() {
            this.$nextTick(() => {
                window["_view"]._tool.endEdit();
                let view = window["_view"];
                view.setFmt(
                    {
                        _blur: this.blurVal,
                    },
                    eFmtSetFlag.ShadowBlur
                );
            });
        }
        changeOffX() {
            this.$nextTick(() => {
                window["_view"]._tool.endEdit();
                let view = window["_view"];
                view.setFmt(
                    {
                        _offset: this.xOffVal,
                    },
                    eFmtSetFlag.ShadowOffsetX
                );
            });
        }
        changeOffY() {
            this.$nextTick(() => {
                window["_view"]._tool.endEdit();
                let view = window["_view"];
                view.setFmt(
                    {
                        _offset: this.yOffVal,
                    },
                    eFmtSetFlag.ShadowOffsetY
                );
            });
        }
        closePresets() {
            this.showPresets = false;
        }
        togglePresets() {
            window["_view"]._tool.endEdit();
            this.showPresets = !this.showPresets;
        }
        presetsText(index = this.activePresets) {
            return Presets[index];
        }

        get activePresetsText() {
            return Presets[this.activePresets];
        }

        handleChangeSet() {
            this.$emit("changeSet");
        }

        get type() {
            //是否disabled
            return this.$store.state.shape.shadowFmt.type;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get activePresets() {
            let pre = this.$store.state.shape.shadowFmt.type;
            if (pre === null) {
                pre = 0;
            }
            return pre;
        }
        set activePresets(v) {
            let payload = {
                type: "type",
                data: v,
            };
            this.$store.commit("setShadowFmtData", payload);
        }
        get sizeVal() {
            return this.$store.state.shape.shadowFmt.size;
        }
        set sizeVal(v) {
            let payload = {
                type: "size",
                data: v,
            };
            this.$store.commit("setShadowFmtData", payload);
        }
        get blurVal() {
            return this.$store.state.shape.shadowFmt.blur;
        }
        set blurVal(v) {
            let payload = {
                type: "blur",
                data: v,
            };
            this.$store.commit("setShadowFmtData", payload);
        }
        get angleVal() {
            return this.$store.state.shape.shadowFmt.angle;
        }
        set angleVal(v) {
            let payload = {
                type: "angle",
                data: v,
            };
            this.$store.commit("setShadowFmtData", payload);
        }
        get xOffVal() {
            return this.$store.state.shape.shadowFmt.offsetX;
        }
        set xOffVal(v) {
            let payload = {
                type: "offsetX",
                data: v,
            };
            this.$store.commit("setShadowFmtData", payload);
        }
        get yOffVal() {
            return this.$store.state.shape.shadowFmt.offsetY;
        }
        set yOffVal(v) {
            let payload = {
                type: "offsetY",
                data: v,
            };
            this.$store.commit("setShadowFmtData", payload);
        }
        get disabledAngle() {
            return this.activePresets < 3;
        }
        get disabledSize() {
            return this.presetsText() === "Inner";
        }

        @Watch("type")
        onTypeChanged(val: any) {
            if (val === null) {
                this.masked = true;
                this.noShadowMasked = false;
            } else if (val === 0) {
                this.masked = true;
                this.noShadowMasked = true;
            } else {
                this.noShadowMasked = false;
                this.masked = false;
            }
        }

        mounted() {
            if (this.type === null) {
                this.masked = true;
                this.noShadowMasked = false;
            } else if (this.type === 0) {
                this.masked = true;
                this.noShadowMasked = true;
            } else {
                this.noShadowMasked = false;
                this.masked = false;
            }
        }
    }
</script>
<i18n>
{
  "zh": {
    "ShadowPanel": {
      "preset": "预定义",
      "size": "大小",
      "blur": "模糊度",
      "angle": "角度",
      "Xoffset": "X轴偏移",
      "Yoffset": "Y轴偏移"
    },
    "No Shadow": "无阴影",
    "Outer": "外阴影",
    "Inner": "内阴影",
    "Perspective": "透视"
  },
  "en": {
    "ShadowPanel": {
      "preset": "Presets",
      "size": "Size",
      "blur": "Blur",
      "angle": "Angle",
      "Xoffset": "X Offset",
      "Yoffset": "Y Offset"
    },
    "No Shadow": "No Shadow",
    "Outer": "Outer",
    "Inner": "Inner",
    "Perspective": "Perspective"
  },
  "fr": {
    "ShadowPanel": {
      "preset": "Préréglages",
      "size": "Taille",
      "blur": "Brouiller",
      "angle": "Angle",
      "Xoffset": "X Offset",
      "Yoffset": "Y Offset"
    },
    "No Shadow": "Pas d'ombre",
    "Outer": "Ombre extérieure",
    "Inner": "Ombre intérieure",
    "Perspective": "Perspective"
  },
  "de": {
    "ShadowPanel": {
      "preset": "Voreinstellungen",
      "size": "Größe",
      "blur": "Wischung",
      "angle": "Winkel",
      "Xoffset": "X Offset",
      "Yoffset": "Y Offset"
    },
    "No Shadow": "Keine Schatten",
    "Outer": "Aussen",
    "Inner": "Innen",
    "Perspective": "Perspektive"
  },
  "jp": {
    "ShadowPanel": {
      "preset": "スタイル",
      "size": "倍率",
      "blur": "ブラー",
      "angle": "角度",
      "Xoffset": "X オフセット",
      "Yoffset": "Y オフセット"
    },
    "No Shadow": "影なし",
    "Outer": "外側の影",
    "Inner": "内側の影",
    "Perspective": "透視"
  },
  "es": {
    "ShadowPanel": {
      "preset": "Preajustes",
      "size": "Tamaño",
      "blur": "Borrón",
      "angle": "Ángulo",
      "Xoffset": "Eje X",
      "Yoffset": "Eje Y"
    },
    "No Shadow": "Sin Sombra",
    "Outer": "Exterior",
    "Inner": "Interior",
    "Perspective": "Perspectiva"
  },
  "pt": {
    "ShadowPanel": {
      "preset": "Predefinições",
      "size": "Tamanho",
      "blur": "Desfoque",
      "angle": "Ângulo",
      "Xoffset": "Compensar em X",
      "Yoffset": "Compensar em Y"
    },
    "No Shadow": "Sem Sombra",
    "Outer": "Exterior",
    "Inner": "Interior",
    "Perspective": "Perspectiva"
  },
  "it": {
    "ShadowPanel": {
      "preset": "Preset",
      "size": "Dimensione",
      "blur": "Sfocatura",
      "angle": "Angolo",
      "Xoffset": "Offset X",
      "Yoffset": "Offset Y"
    },
    "No Shadow": "Nessuna Ombra",
    "Outer": "Esterna",
    "Inner": "Interna",
    "Perspective": "Prospettiva"
  },
  "tw": {
    "ShadowPanel": {
      "preset": "預定義",
      "size": "大小",
      "blur": "模糊度",
      "angle": "角度",
      "Xoffset": "X軸偏移",
      "Yoffset": "Y軸偏移"
    },
    "No Shadow": "無陰影",
    "Outer": "外陰影",
    "Inner": "內陰影",
    "Perspective": "透視"
  }
}
</i18n>
